import { FC, useState, createContext } from 'react';
type CollapseContext = { collapseToggle: any; toggleCollapse: () => void };

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollapseContext = createContext<CollapseContext>(
  {} as CollapseContext
);

export const CollapseProvider: FC = ({ children }) => {
  const [collapseToggle, setCollapseToggle] = useState(true);
  const toggleCollapse = () => {
    setCollapseToggle(!collapseToggle);
  };

  return (
    <CollapseContext.Provider value={{ collapseToggle, toggleCollapse }}>
      {children}
    </CollapseContext.Provider>
  );
};
